const SeatsResults = {
  Seats: Symbol('seats'),
  HasFreeSeat: Symbol('hasFreeSeat'),
};

export default SeatsResults;
